exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.orangeConfirmationButton[data-v-2574e4d8] {\n  margin-top: 5%;\n}\n@media (max-width:  768px) {\n.col-md-3[data-v-2574e4d8] {\n    margin-top: -20px;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2574e4d8","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/user/CMProfile.vue
// module id = 1520
// module chunks = 2